import ItemFilterBar from "../../../CommonElements/Table/ItemFilterBar";
import SearchBar from "../../../CommonElements/Table/SearchBar";
import DATA_TYPE from "../../../Constant/DataType";
import SubHeaderComponentLayout from "../../../Layout/Components/SubHeaderComponentLayout";

const CalendarHeaderComponent = ({ handleSearch, handleFilter, unitKerja }) => {
  return (
    <SubHeaderComponentLayout
      handleSearch={(e) => handleSearch(e.target.value)}
      handleFilter={(e, key) => handleFilter(e.target.value, key)}
      listData={{
        [DATA_TYPE.UnitKerja]: {
          label: "DPSJ",
          data: unitKerja,
          id: "pk",
          featureName: "nama_unit_kerja",
          col: "6",
        },
      }}
    />
  );
};

export default CalendarHeaderComponent;
